import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { EncryptionHelper } from '../../shared/helpers/encryption-helper';

@Injectable()
export class EncryptionInterceptor implements HttpInterceptor {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let modifiedReq = req;

        if (req.url.includes('/notification-hub')) {
            return next.handle(req); // 🚫 Skip encryption
        }

        // Encrypt the request body for POST and PUT requests
        if ((req.method === 'POST' || req.method === 'PUT') && req.body && !(req.body instanceof FormData)) {
            try {
                const encryptedBody = EncryptionHelper.encrypt(JSON.stringify(req.body)); // Encrypt the body
                modifiedReq = req.clone({
                    body: { body: encryptedBody }, // Wrap encrypted data in "body" property
                });
            } catch (error) {
                console.error('Encryption failed', error);
            }
        }

        // Handle response decryption
        return next.handle(modifiedReq).pipe(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            map((event: HttpEvent<any>) => {
                if (
                    event instanceof HttpResponse &&
                    event.body?.body
                ) {
                    if (typeof event.body.body === 'string') {
                        try {
                            const decryptedData = EncryptionHelper.decrypt(event.body.body); // Decrypt the body
                            const parsedData = JSON.parse(decryptedData); // Parse the decrypted JSON
                            return event.clone({ body: parsedData }); // Clone response with decrypted data
                        } catch (error) {
                            console.error('Decryption failed', error);
                            return event;
                        }
                    }
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                if (error.error?.body && typeof error.error.body === 'string') {
                    try {
                        const decryptedError = EncryptionHelper.decrypt(error.error.body);
                        const parsedError = JSON.parse(decryptedError);
                        const clonedError = new HttpErrorResponse({
                            error: parsedError,
                            headers: error.headers,
                            status: error.status,
                            statusText: error.statusText,
                            url: error.url || undefined,
                        });
                        return throwError(() => clonedError);
                    } catch (decryptionError) {
                        console.error('Error decryption failed:', decryptionError);
                    }
                }
                return throwError(() => error);
            })
        );
    }
}
